/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultAgent } from '../../models/api-response-paged-result-agent';
import { PagedRequestAgent } from '../../models/paged-request-agent';

export interface SearchAgent$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestAgent
}

export function searchAgent(http: HttpClient, rootUrl: string, params: SearchAgent$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultAgent>> {
  const rb = new RequestBuilder(rootUrl, searchAgent.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultAgent>;
    })
  );
}

searchAgent.PATH = '/v1/api/ui/agent/search';
